/* Hada Labo: keep visitors in their language (sl/en). Runs before paint. */
(function () {
  try {
    if (!window.Shopify || !Shopify.routes) return;
    var root = Shopify.routes.root;               // "/" (en) or "/sl/"
    if (root !== '/' && root !== '/sl/') return;  // other markets: do nothing
    var cur = root === '/sl/' ? 'sl' : 'en';
    var KEY = 'hl_lang', SEEN = 'hl_seen';
    var saved = null; try { saved = localStorage.getItem(KEY); } catch (e) {}
    var seen = false; try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}
    if (seen) { try { localStorage.setItem(KEY, cur); } catch (e) {} return; } // navigating: current = preference
    try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}
    var pref = saved;
    if (!pref) {
      var nav = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      pref = /^sl/i.test(nav) ? 'sl' : cur;
    }
    try { localStorage.setItem(KEY, pref); } catch (e) {}
    if (pref === cur) return;
    var p = location.pathname, target;
    if (pref === 'sl') target = '/sl' + (p === '/' ? '' : p);
    else target = p.replace(/^\/sl(\/|$)/, '/');
    if (!target) target = '/';
    if (target !== p) location.replace(target + location.search + location.hash);
  } catch (e) {}
})();

/* HL: stil za Shopify cookie baner (assets/hl-cookie-banner.css), Claude 26.09. */
(function () {
  try {
    var s = document.currentScript && document.currentScript.src;
    if (!s || document.getElementById('hl-cookie-css')) return;
    var l = document.createElement('link');
    l.id = 'hl-cookie-css';
    l.rel = 'stylesheet';
    l.href = s.replace(/hl-locale\.js(\?.*)?$/, 'hl-cookie-banner.css');
    document.head.appendChild(l);
  } catch (e) {}
})();

/* HL: "Dodaj v košarico" na PDP-u (glavno + sticky dugme), Claude 29.09.
   1) bold tekst  2) CRNA boja (test — za povratak na crvenu obrisati red CRNA)
   3) vidljiv pritisak prstom (smanji se + potamni) i kružić dok se dodaje u korpu
   4) cimanje kao na magicbeauty.rs (vidi sledeći blok) */
(function () {
  try {
    if (document.getElementById('hl-bold-atc')) return;
    var S = '[id*="__sticky_add_to_cart"] button';
    var st = document.createElement('style');
    st.id = 'hl-bold-atc';
    st.textContent = '.hl-atc,.hl-atc span{font-weight:700!important}' +
      /* CRNA */ '.hl-atc,' + S + '{background:#1B1B1B!important;border-color:#1B1B1B!important}.hl-atc:hover,' + S + ':hover{background:#000!important}.hl-atc[disabled],' + S + '[disabled]{background:#999!important;border-color:#999!important}' +
      /* PRITISAK */ '.hl-atc,' + S + ',.hl-mini,.hl-qa-btn{-webkit-tap-highlight-color:transparent;transition:transform .12s ease,filter .12s ease,background .2s ease,box-shadow .2s ease!important}' +
      '.hl-atc:active,' + S + ':active,.hl-mini:active{transform:scale(.96)!important;filter:brightness(.8)}' +
      '.hl-atc{position:relative}.hl-atc.loading{opacity:1!important}.hl-atc.loading>span{visibility:hidden}' +
      '.hl-atc.loading::after{content:"";position:absolute;left:50%;top:50%;width:22px;height:22px;margin:-11px 0 0 -11px;border:2.5px solid rgba(255,255,255,.35);border-top-color:#fff;border-radius:50%;animation:hlspin .7s linear infinite}' +
      '@keyframes hlspin{to{transform:rotate(360deg)}}' +
      /* CIMANJE — isto kao magicbeauty.rs: levo-desno ~4px, ~0,8 s, 4 zamaha */
      '@keyframes hlnudge{0%{transform:translateX(0)}6%{transform:translateX(-1px)}12.5%{transform:translateX(3px)}25%{transform:translateX(-4px)}37.5%{transform:translateX(3px)}50%{transform:translateX(-4px)}62.5%{transform:translateX(3px)}75%{transform:translateX(-3px)}87.5%{transform:translateX(1px)}100%{transform:translateX(0)}}' +
      '.hl-nudge{animation:hlnudge .8s linear}';
    document.head.appendChild(st);
    /* iOS Safari prikazuje :active tek kad postoji touch listener */
    document.addEventListener('touchstart', function () {}, { passive: true });
  } catch (e) {}
})();

/* HL: cimanje "Dodaj v košarico" kao na magicbeauty.rs — na svakih 7 s, bez ograničenja.
   Cima se dugme koje je trenutno na ekranu: sticky traka (kad je vidljiva) ili glavno dugme.
   Ne cima dok se dodaje u korpu, kad je tab u pozadini ili uz "reduce motion". Claude 30.09. */
(function () {
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var EVERY = 7000;
    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
    }
    function pick() {
      var bar = document.querySelector('[data-hl-sticky].on');
      var b = bar && bar.querySelector('button:not([disabled])');
      if (b) return b;
      var m = document.querySelector('.hl-atc:not([disabled])');
      if (m && inView(m)) return m;
      return null;
    }
    setInterval(function () {
      if (document.hidden) return;
      var b = pick();
      if (!b || b.classList.contains('loading') || b.matches(':active')) return;
      b.classList.remove('hl-nudge'); void b.offsetWidth; b.classList.add('hl-nudge');
      setTimeout(function () { b.classList.remove('hl-nudge'); }, 900);
    }, EVERY);
  } catch (e) {}
})();

/* HL: swipe galerija na karticama proizvoda — tačkice + strelice (Claude 29.09.) */
(function () {
  try {
    function upd(sl) {
      var w = sl.clientWidth; if (!w) return;
      var i = Math.round(sl.scrollLeft / w);
      var d = sl.parentNode.querySelectorAll('.hl-dots i');
      for (var k = 0; k < d.length; k++) d[k].classList.toggle('on', k === i);
    }
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('hl-slides') || t._hlr) return;
      t._hlr = requestAnimationFrame(function () { t._hlr = 0; upd(t); });
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-hl-arr]') : null;
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var sl = b.parentNode.querySelector('.hl-slides'); if (!sl) return;
      var w = sl.clientWidth, n = sl.children.length;
      var i = Math.round(sl.scrollLeft / w) + parseInt(b.getAttribute('data-hl-arr'), 10);
      if (i < 0) i = n - 1; if (i >= n) i = 0;
      sl.scrollTo({ left: i * w, behavior: 'smooth' });
      setTimeout(function () { upd(sl); }, 400);
    }, true);
  } catch (e) {}
})();